import React from 'react';
import { Card } from '../../types/Card';
import { CardPreview } from './CardPreview';

interface CardGridProps {
  cards: Card[];
  onCardPin: (cardId: string) => void;
  onCardRegenerate: (cardId: string) => void;
  onCardEdit: (card: Card) => void;
}

export const CardGrid: React.FC<CardGridProps> = ({
  cards,
  onCardPin,
  onCardRegenerate,
  onCardEdit,
}) => {
  if (cards.length === 0) {
    return (
      <div className="card-grid-empty">
        <p>No cards generated yet. Generate cards from your topics to get started.</p>
      </div>
    );
  }

  return (
    <div className="card-grid">
      {cards.map((card) => (
        <CardPreview
          key={card.id}
          card={card}
          onPin={() => onCardPin(card.id)}
          onRegenerate={() => onCardRegenerate(card.id)}
          onEdit={() => onCardEdit(card)}
        />
      ))}
    </div>
  );
};
